import React, { memo } from 'react'

import {
  arrayOf, object, shape, oneOf, number, string,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CategoryCard from './CategoryCard'

function CategoryGrid({ categories, gridLayoutConfig = EMPTY_ARRAY, className = '' }) {
  const getCardSize = (index) => {
    if (gridLayoutConfig && gridLayoutConfig.length > 0) {
      const rule = gridLayoutConfig.find((config) => config.index === index)
      return rule ? rule.size : 'default'
    }

    return 'default'
  }

  return (
    <div className={className ? `category-grid ${className}` : 'category-grid'}>
      {categories?.map((category, index) => {
        const cardSize = getCardSize(index)

        return (
          <div
            key={category.id || index}
            className={`category-grid__item category-grid__item--${cardSize}`}
          >
            <CategoryCard
              title={category.title}
              modelsCount={category.itemCount}
              href={category.path}
              imageUrl={category.image}
              slug={category.slug}
              productType={category.productType}
            />
          </div>
        )
      })}
    </div>
  )
}

CategoryGrid.propTypes = {
  categories: arrayOf(object).isRequired,
  className: string,
  gridLayoutConfig: arrayOf(
    shape({
      index: number.isRequired,
      size: oneOf(['default', 'wide', 'tall']).isRequired,
    })
  ),
}

// Relies on `categories` being referentially stable (memoized in AssetCollection).
export default memo(CategoryGrid)
